import React from 'react';

const AdminUsers = () => (
  <div className="admin-users">
    <h3>Users Management</h3>
    <p>List / search / block / create users — UI to be implemented.</p>
  </div>
);

export default AdminUsers;
